import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { memo } from 'react'
import { SettingsProvider } from 'Features/Projects/Scenarios/EditSettings/SettingsProvider'

/**
 * The scenario's settings routes. Navigation between them is the project
 * sidebar's scenario mode (Projects/Navigation.view.tsx) and the crumb trail is
 * the shell's, so this is only the shared settings state around the page.
 */
export const EditSettingsView = memo(() => (
  <SettingsProvider>
    <Box
      sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}
    >
      <Outlet />
    </Box>
  </SettingsProvider>
))
